import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Header from './Header.jsx';
import styles from "./Followers.module.css";
import defaultPicture from "../assets/default_pfp.png";
import "./Requests.css";
import translations from "./translation.js";

const Requests = () => {
  const [connections, setConnections] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);
  const { userID } = useParams();
  const link1 = "/user/" + userID + "/following";
  const link2 = "/user/" + userID + "/followers";
  const link3 = "/user/" + userID + "/blocked";
  const link4 = "/user/" + userID + "/requests";
  const currentLanguage = localStorage.getItem('selectedLanguage') || "en";
  const [connectionID, setConID] = useState(null);
  const [revConID, setRevConID] = useState(null);
  let [stat, setStat] = useState(null);
  
  console.log(revConID, connectionID);

  const callConnection = (stat, user) => {
    checkConnections(user);
    checkReverseConnections(user);
    setStat(stat);
  };

  const checkConnections = async (user) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_PATH}/connections?fromUserID=${sessionStorage.getItem("user")}&toUserID=${user}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        if (data[0].length !== 0) {
          for (let i = 0; i < Object.keys(data[0]).length; i++) {
            if (data[0][i].attributes.connection) {
              setConID(data[0][i].id);
            }
          }
        }
      } else {
        throw new Error('Failed to fetch connections');
      }
    } catch (error) {
      console.error('Error checking connections:', error);
    }
  };

  const checkReverseConnections = async (user) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_PATH}/connections?fromUserID=${user}&toUserID=${sessionStorage.getItem("user")}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        if (data[0].length !== 0) {
          for (let i = 0; i < Object.keys(data[0]).length; i++) {
            if (data[0][i].attributes.connection) {
              setRevConID(data[0][i].id);
            }
          }
        }
      } else {
        throw new Error('Failed to fetch connections');
      }
    } catch (error) {
      console.error('Error checking reverse connections:', error);
    }
  };

  useEffect(() => {
    if (connectionID !== null && revConID !== null) {
      patchConnection();
    }
  }, [connectionID, revConID]);

  const patchConnection = async () => {
    if (stat === 2) { stat = -1 }
    if (stat === 5) { stat = 4 }
    let rev = 0 - stat;
    try {
      await fetch(process.env.REACT_APP_API_PATH + "/connections/" + connectionID, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify({
          attributes: { connection: rev },
        }),
      });
      await fetch(process.env.REACT_APP_API_PATH + "/connections/" + revConID, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify({
          attributes: { connection: stat },
        }),
      });
      console.log("Connection made successfully");
      loadRequests();
    } catch (error) {
      console.error("Error patching connection:", error);
    }
  };

  useEffect(() => {
    loadRequests();
  }, []);

  const loadRequests = () => {
    fetch(
      process.env.REACT_APP_API_PATH +
      "/connections?fromUserID=" + userID,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then(res => res.json())
      .then(data => {
        const allowedConnections = [-2, 2, -5, 5];
        const newConnections = [];
        for (let i = 0; i < Object.keys(data[0]).length; i++) {
          if (data[0][i].attributes.connection && allowedConnections.includes(data[0][i].attributes.connection)) {
            newConnections.push({
              username: data[0][i].toUser.attributes.username,
              picture: data[0][i].toUser.attributes.picture || defaultPicture,
              id: data[0][i].toUser.id,
              connection: data[0][i].attributes.connection
            });
          }
        }
        setConnections(newConnections);
        setIsLoaded(true);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        setError(error);
      });
  };

  return (
    <div className={styles.bg}>
      <Header />
      <div className={styles.navContainer}>
        <Link to={link1}><button className={styles.navBtn}>{translations[currentLanguage].following}</button></Link>
        <Link to={link2}><button className={styles.navBtn}>{translations[currentLanguage].followers}</button></Link>
        <Link to={link3}><button className={styles.navBtn}>{translations[currentLanguage].blocked}</button></Link>
        <Link to={link4}><button className={styles.currBtn}>{translations[currentLanguage].requests}</button></Link>
      </div>
      <div className={styles.connectionsContainer}>
        {isLoaded ? (
          connections.map((connection, index) => (
          <div key={index} className={styles.connectionItem}>
            <Link to={`/user/${connection.id}`} className="connection-pic">
              <img src={connection.picture} alt="user avatar" />
            </Link>
            <span>{connection.username}</span>
            {(connection.connection === 5 || connection.connection === 2) && (userID === sessionStorage.getItem("user")) ? (
              <button onClick={() => callConnection(connection.connection, connection.id.toString())}>
                {userID === sessionStorage.getItem("user") ? "FOLLOW" : ""}
              </button>
            ) : null}
          </div>
          ))
        ) : (
          <p>Loading...</p>
        )}
        {error && <p>Error: {error.message}</p>}
      </div>
    </div>
  );
}

export default Requests;
